import { Component } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { LoaderService } from '../../core/services/loading.service';

@Component({
    selector: 'app-programs',
    templateUrl: './programs.component.html',
    standalone: false
})
export class ProgramsComponent {
    resp: { panelDetails: { panelInfos: { accessiblePanels: string[]; userWidgets: { widgetId: any; userWidget: any; userWidgetDetail: any; dashboard: any; valuationDate: any; columnInDashboard: number; orderInDashboard: number; editingValuationDate: boolean; editedValuationDate: boolean; id: string; type: string; toggled: boolean; safeColumn: number; widgetPath: string; }[]; serviceFunctionsVisibility: { "Add New WC Posting Notice Request": boolean; "Add New Policy Service Request": boolean; "Service Requests": boolean; }; programShortcutFunctionsVisibility: { "ACCOUNT POLICY DOWNLOAD": boolean; "SOLD PROPOSAL": boolean; DRAFT: boolean; }; }[]; }[]; };
    showSRPanel: boolean = false;
    showProgramSearch: boolean = false;
    showShortcuts: boolean = false;
    showRecentPrograms: boolean = false;

    constructor(public apiService: ApiService, public loaderService: LoaderService) { }

    ngOnInit() {
        const payload = {
            "panelInfo": {
                "headerMenu": "PROGRAM"
            },
            "organizationId": this.loaderService.getItem('orgId'),
            "applicationAccntDtlId": this.loaderService.getItem('appAccountDetailId'),
            "actionType": "RETRIEVE",
            "panelDetailType": "PANELS_ON_LOAD"
        };
        this.apiService.postData('panels', payload).subscribe({
            next: (resp) => {
                this.loaderService.hideLoader();
                if (resp.panelDetails[0].panelInfos[0].userWidgets) {
                    resp.panelDetails[0].panelInfos[0].userWidgets.forEach(element => {
                        if (element.type === 'SERVICE_REQUESTS_PANEL') {
                            this.showSRPanel = true;
                        }
                        if (element.type === 'PROGRAM_SEARCH') {
                            this.showProgramSearch = true;
                        }
                        if (element.type === 'PROGRAM_SHORTCUTS') {
                            this.showShortcuts = true;
                        }
                        if (element.type === 'PROGRAM_RECENT') {
                            this.showRecentPrograms = true;
                        }
                    });
                }
                if (resp.panelDetails[0].panelInfos[0].programShortcutFunctionsVisibility) {
                    this.loaderService.setItem('programShortcuts', JSON.stringify(resp.panelDetails[0].panelInfos[0].programShortcutFunctionsVisibility));
                }
                if (resp.panelDetails[0].panelInfos[0].serviceFunctionsVisibility) {
                    this.loaderService.setItem('serviceFunctionsLinks', JSON.stringify(resp.panelDetails[0].panelInfos[0].serviceFunctionsVisibility));
                }
            },
            error: (error) => {
                this.loaderService.hideLoader();
            }
        })
    }

    getApplicationId() {
        const encodedId = this.loaderService.getItem('appAccountDetailId');
        if (!encodedId) return null;

        const decodedId = encodedId;
        return Number(decodedId) === 0 ? null : decodedId;
    }
}
